import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { TemplateWaListPage } from '@/features/marketing'

export const Route = createFileRoute('/_authenticated/marketing/templates')({
  component: () => (
    <RequirePermission permission='marketing.read'>
      <TemplateWaListPage />
    </RequirePermission>
  ),
})
